export default "__VITE_ASSET__1e0038ca__"